import type { SerializedReseller } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import type { UpdateResellersArgs } from 'lib/services/resellersApi';
import { useMutation, type UseMutationResult } from 'react-query';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useUpdateReseller = (
  onSuccess: () => void,
): UseMutationResult<SerializedReseller, unknown, UpdateResellersArgs> => {
  const { resellersApiClient } = useServices();

  return useMutation((args: UpdateResellersArgs) => resellersApiClient.update(args), {
    mutationKey: MUTATION_KEYS.resellers.updateOne(),
    onError: error => {
      if (error instanceof Error) {
        notifyError(error, {
          message: 'There was an error while updating reseller',
        });
      }
    },
    onSuccess: () => {
      notifySuccess({
        message: `Reseller updated`,
      });
      onSuccess();
    },
  });
};
